
try {
/*
 * main scripts
 */
(function($, win, doc, RAF) {

    var $body = $('body'),
        $win = $(win);

    // optimize to use passive setting that's not supported in jQuery
    // @link https://developers.google.com/web/tools/lighthouse/audits/passive-event-listeners
    var onScroll = function(callback) {
        if (win.addEventListener) {
            win.addEventListener('scroll', callback, {
                passive: true
            });
        } else {
            $win.on('scroll', callback);
        }
    }
    var offScroll = function(callback) {
        if (win.removeEventListener) {
            win.removeEventListener('scroll', callback);
        } else {
            $win.off('scroll', callback);
        }
    }

    var config = $('meta[name=verkoop]').attr('content');
    if (typeof config === 'string') {
        try {
            win.vkConfig = JSON.parse(config);
        } catch (e) {
            console.error('Failed to parse SEO shop javascript config.');
        }
    }
    var vkConfig = win.vkConfig;

    var vk_domain = doc.location.host;
    var phone = $('head > meta[name="phone"]').attr('content') || '+31 (0)6 25 14 06 28';

    /*var script = doc.createElement('script');
    script.setAttribute('src', '/services/stats/pageview.js');
    var scriptElement = doc.getElementById('o10n');
    scriptElement.parentNode.insertBefore(script, (scriptElement.nextSibling ? scriptElement.nextSibling : scriptElement));*/

    var host_regex = new RegExp("^(http(s)?:)?//" + doc.location.host, "i");
    function rewrite_ext_links(links) {
        if (!links) {
            links = $('a[target=_blank]').not('a[rel]');
        }

        links.each(function(i, el) {
            var href = $(el).attr('href');
            if (host_regex.test(href)) {
                $(el).attr('rel', 'noopener');
            }
        });
    }

    // sidebar
    var now = Date.now();
    var interval = 10 * 60e3;
    var shift = (Math.sin(1202441)||0)*interval;
    var cachebust = Math.floor((now+shift)/interval);
    $async({
        "src": "https://dashboard.webwinkelkeur.nl/sidebar.js?id=1202441&c=" + cachebust,
        "exec_timing": "requestIdleCallback"
    }).then(function() {

        var rewritten;
        function rewrite_wwk() {
            if ($('a.wwk--i18n').length) {
                rewrite_ext_links($('a.wwk--i18n'))
                rewritten = true;
            }
            return rewritten;
        }

        if (!rewrite_wwk()) {
            var count = 0;
            var wwkInterval = setInterval(function() {
                count++;
                if (rewrite_wwk() || count > 100) {
                    clearInterval(wwkInterval);
                }
            },100);
        }
    });

    $body.on('click', '.morestock', function() {
        var reg = $(".stocksignal_register").first();
        if (reg.length) {
            $('html, body').animate({
                scrollTop: $(reg).offset().top - 70
            }, 800, 'swing', function() {
                $('.email input', reg).focus();
            });
        }
    });

    $body.on('click', '#cookielaw_optin', function() {
        var now = new Date();
        var time = now.getTime();
        var expireTime = time + (1000 * 86400 * 90);
        now.setTime(expireTime);
        doc.cookie = 'COOKIELAW=optin;expires=' + now.toGMTString() + ';path=/';
        $('.wsa-cookielaw').remove();
        doc.documentElement.classList.remove('cookielaw');
    });

    // Target your .container, .wrapper, .post, etc.
    // $("#product-tab-content").fitVids();

    function getAjaxTranslation(key) {
        if (translation = eval('ajaxTranslations["' + key + '"]')) {
            return translation;
        }
        return key;
    }

    var isSticky, stickyScrollTimeout;
    var affixNav;
    var stickyCheck = function() {
        if (!stickyScrollTimeout) {
            stickyScrollTimeout = setTimeout(function() {
                var height = $win.scrollTop()
                var header = $('header').first();
                var headerBottom = header.position().top + header.height();
                stickyScrollTimeout = null;
                if (height > headerBottom) {

                    if (isSticky) {
                        return;
                    }

                    if (!affixNav) {
                        $('#stickynav').after($('<div id="affixnav" style="display:none"></div>'));
                        affixNav = $('#affixnav');
                        var clone = $('#stickynav').clone();
                        clone.attr('id', '');
                        affixNav.append(clone);
                    }

                    affixNav.show();

                    isSticky = true;
                } else {

                    if (!isSticky) {
                        return;
                    }

                    affixNav.hide();

                    isSticky = false;
                }
            }, 50);
        }
    };
    onScroll(stickyCheck);
    stickyCheck();

    /*$('.cart, .view-cart').hover(
        function() {
            $('.view-cart').css('display', 'block');
        },
        function() {
            $('.view-cart').css('display', 'none');
        }
    );*/
    //livesearch activeren  

    $body.on('click', ".navbar-toggle", function() {
        $(".navbar-toggle").toggleClass("show");
        $(".nav-arrow").toggleClass("show");
    });
    $body.on('click', ".cartmobile a.cart", function() {
        $(".view-cartmobile").toggleClass("show");
    });

    //enable fancybox on thumbs
    $body.on('mouseover touchstart click', '.fancybox-thumb', function() {

        var pswp_css_loaded;

        var $pswp = $('.pswp')[0];
        $('.productpage-images').each(function() {
            var $pic = $(this),
                getItems = function() {
                    var items = [];
                    $pic.find('.fancybox-thumb').each(function() {
                        var $href = $(this).attr('href');

                        var item = {
                            src: $href,
                            w: 1600,
                            h: 1600
                        }

                        items.push(item);
                    });
                    return items;
                }
            var items = getItems();

            $pic.on('click', '.fancybox-thumb', function(event) {
                event.preventDefault();

                var $index = $(this).index('.productpage-images');

                function load_image() {

                    var options = {
                        index: $index,
                        bgOpacity: 0.7,
                        showHideOpacity: true,
                        history: false,
                        shareButtons: [{
                            id: 'download',
                            label: 'Download image',
                            url: '{{raw_image_url}}',
                            download: true
                        }, {
                            id: 'pinterest',
                            label: 'Pin it',
                            url: 'http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}'
                        }, {
                            id: 'facebook',
                            label: 'Share on Facebook',
                            url: 'https://www.facebook.com/sharer/sharer.php?u={{url}}'
                        }, {
                            id: 'twitter',
                            label: 'Tweet',
                            url: 'https://twitter.com/intent/tweet?text={{text}}&url={{url}}'
                        }]
                    }

                    // Initialize PhotoSwipe
                    var lightBox = new PhotoSwipe($pswp, PhotoSwipeUI_Default, items, options);
                    lightBox.init();

                    ga('send', 'event', 'photo', $index);
                }

                if (!pswp_css_loaded) {
                    pswp_css_loaded = 1;
                    win.pscss();
                    win.psjs().then(function() {
                        $async.time("requestAnimationFrame", function() {
                            load_image();
                        });
                    })
                } else {
                    load_image();
                }
            });
        });

        // fancy js
        //psjs().then(function() {
          //  $('.fancybox-thumb').


            /*fancybox({
                padding: 0,
                openEffect: 'elastic',
                closeEffect: 'elastic',
                prevEffect: 'elastic',
                nextEffect: 'elastic',
                helpers: {
                    thumbs: {
                        width: 60,
                        height: 60
                    },
                    media: {}
                },
                keys: {
                    close: [27, 32]
                }
            });*/
       // });
    });

    $body.on('click', '.stickysearch', function() {
        var box = $('.view-search', $(this).parent());
        if (box.hasClass('open')) {
            box.removeClass('open');
            setTimeout(function() {
                box.addClass('hidden');
            }, 120);
        } else {
            box.removeClass('hidden');
            setTimeout(function() {
                box.addClass('open');
            }, 20);
        }
    });

    $(".single-item1").hover(
        function() {
            $('.menublock').addClass('hidden');
        }, function() {
            $('.menublock').removeClass('hidden');
        }
    );
    $(".single-item1, .has-submenu").hover(
        function() {
            $('.pagecur').removeClass('current');
        }, function() {
            $('.pagecur').addClass('current');
        }
    );

    $body.on('click', '#filtertoggle, .closeit', function(e) {
        content.toggleClass('open closed');
        content.contentHeight = content.outerHeight();
        if (content.hasClass('closed')) {
            // disable transitions & set max-height to content height
            content.removeClass('transitions').css('max-height', content.contentHeight);
            setTimeout(function() {
                // enable & start transition
                content.addClass('transitions').css({
                    'max-height': 0,
                    'opacity': 0
                });
            }, 10); // 10ms timeout is the secret ingredient for disabling/enabling transitions
            // chrome only needs 1ms but FF needs ~10ms or it chokes on the first animation for some reason

        } else if (content.hasClass('open')) {
            content.contentHeight += content.inner.outerHeight(); // if closed, add inner height to content height
            content.css({
                'max-height': content.contentHeight,
                'opacity': 1
            });
        }
    });

    var scrollState;
    onScroll(function() {
        if (scrollState !== 1 && $(this).scrollTop() > 400) {
            $('.scrollToTop').fadeIn();
            scrollState = 1;
        } else if (scrollState !== 0) {
            $('.scrollToTop').fadeOut();
            scrollState = 0;
        }
    });

    $win.on('resize', function() {
        if ($win.width() > 992) {
            $('#menu').addClass('open');
        }
    });

    // Open menu op click op mobiel
    $body.on('click', '#menu-toggle', function() {
        $('#menu').toggleClass('open');
    });

    //MENU3LAAGS Bekijk of sub-menu class active heeft en voeg dan + of - toe    
    $body.on('click', '.menu3laags .has-submenu > .togglesub', function() {
        if ($(this).parent().children('ul.sub-menu').hasClass('active')) {
            $(this).html('<i class="fa fa-plus" aria-hidden="true"></i>');
        } else {
            $(this).html('<i class="fa fa-minus" aria-hidden="true"></i>');
        }
        $(this).parent().children('ul.sub-menu').toggleClass('active');
    });

    //MENU2LAAGS Bekijk of sub-menu class open heeft en voeg dan + of - toe    
    $body.on('click', '.menu2laags .togglesub', function() {
        if ($(this).parent().hasClass('open')) {
            $(this).html('<i class="fa fa-plus" aria-hidden="true"></i>');
        } else {
            $(this).html('<i class="fa fa-minus" aria-hidden="true"></i>');
        }
        $(this).parent().children('ul.sub-menu').toggleClass('active');
    });
    $body.on('mouseover', '.navbar li ul.dropdown-menu', function() {
        $(this).parent().toggleClass('active');
    });

    $body.on('mouseover', '#menu li ul.sub-menu', function() {
        $(this).parent().toggleClass('current');
    });

    if ($('.menu2laags').length > 0) {
        var responsiveWidth = 991;
        var fixedMenuOffset = (this.top = $('header').outerHeight(true) - $('#navbar').outerHeight(true));
        if ($win.innerWidth() >= responsiveWidth) {
            menu2laagsPositioner();
        }

        var affixMenuOn = false;
        onScroll(function() {
            if ($(doc).scrollTop() < fixedMenuOffset && affixMenuOn == true) {
                if ($win.innerWidth() >= responsiveWidth) {
                    affixMenuOn = false;
                    menu2laagsPositioner();
                }
            } else if ($(doc).scrollTop() > fixedMenuOffset && affixMenuOn == false) {
                if ($win.innerWidth() >= responsiveWidth) {
                    affixMenuOn = true;
                    menu2laagsPositioner();
                }
            }
        });
        $win.on('resize', function() {
            if ($win.innerWidth() >= responsiveWidth) {
                menu2laagsPositioner();
            } else {
                $('.menu2laags #navbar .nav .dropdown-menu').removeAttr('style');
            }
        });
    }

    function menu2laagsPositioner() {
        var selector = '.menu2laags #navbar .nav';
        //var singleHeight = $(selector+' > li:first-child').outerHeight();
        $(selector + ' > li').each(function() {
            if ($('.dropdown-menu', this).length > 0) {
                var offset = $(this).position();
                var height = $(this).outerHeight();
                //var row = offset.top / singleHeight;
                $('.dropdown-menu', this).css('top', (height + offset.top) + 'px');
            }
        });
    }

    //$body.on('mouseenter', '.productpage-images-thumbs img', 'productpage-images-featured img', function(e) {
        // $('.productpage-images-featured .featured').attr('src', $(this).attr('data-featured-url')).attr('data-original-url', $(this).attr('data-original-url'));
        // $('.zoomImg').remove();
        // $('.productpage-images-featured').zoom({ on: 'mouseover' });
    //});

    //Click event to scroll to top
    $body.on('click', '.scrollToTop, .scrollToTopSticky', function() {
        $('html, body').animate({
            scrollTop: 0
        }, 800);
        return false;
    });
    /*
        if (fakewaffle) {
            fakewaffle.responsiveTabs(['xs', 'sm']);
        }*/


    /**
     * Optimization
     * Moved dynamic javascript to main.js
     * @link https://optimalisatie.nl/
     */

    var searchUrl = 'https://'+vk_domain+'/search/';

    $body.on('click', ".show-more > span", function() {
        $(this).html(function(i, v) {
            return v === vkConfig[3] + ' <span class="glyphicon glyphicon-chevron-up"></span>' ? vkConfig[2] + ' <span class="glyphicon glyphicon-chevron-down"></span>' : vkConfig[3] + ' <span class="glyphicon glyphicon-chevron-up"></span>'
        })
        $(".collection-content").toggleClass("long");
    });

    var $productFooter = $('#product_footer');
    if ($productFooter.length && $('#product_configure_form_footer').length) {
        var $formElements = $productFooter.find('input,select,radio,textarea,button,a');
        $formElements.each(function() {
            var $this = $(this);
            var onclick = $this.attr('onclick');
            var onchange = $this.attr('onchange');
            var id = $this.attr('id');
            var attr = {};
            if (onclick) {
                onclick = onclick.replace(/product_configure_form/g, 'product_configure_form_footer');
                $this.attr('onclick', onclick);
                attr['onclick'] = onclick;
            }
            if (onchange) {
                onchange = onchange.replace(/product_configure_form/g, 'product_configure_form_footer');
                $this.attr('onchange', onchange);
                attr['onchange'] = onchange;
            }
            // Change action.
            $.each(attr, function(key, val) {
                var prepos = val.indexOf('.action');
                if (-1 !== prepos) {
                    // Er wordt een actie overschreven.
                    var search = "/';";
                    var searchpos = prepos + val.substring(prepos).indexOf(search);
                    // ++ omdat we na de / moeten invoegen.
                    searchpos++;
                    if (-1 !== searchpos) {
                        var newval = val.slice(0, searchpos) + "#product_footer" + val.slice(searchpos);
                        $this.attr(key, newval);
                    }
                }
            });

            // Set id/for pairs to unique values.
            if (id) {
                var $label = $('label[for="' + id + '"]', $productFooter);
                id = id + '_footer';
                $this.attr('id', id);
                if ($label.length) {
                    $label.attr('for', id);
                }
            }
        });
    }

    if (doc.getElementById('related_products')) {

        RAF(function() {

            $('#related_products').append('<div id="related_carousel" class="owl-carousel owl-theme" style="padding:0px;"></div>');

            if ($('#related_products > div').length && $('#related_products > div').slice(4).length) {

                $('#related_products > div').slice(4).each(function(i, el) {
                    $(el).removeClass('col-xs-6').removeClass('col-sm-3').removeClass('col-md-3').addClass('col-xs-12').css({
                        visibility: 'hidden'
                    });
                    var img = $('img', $(el));
                    if ($(img).data('src')) {
                        $(img).attr('src', $(img).data('src'));
                    }
                    $('#related_carousel').append(el);
                });
            }

            // #related_products,.carousel-brands,#headlines,#related_carousel
            $lazy('#related_products,.carousel-brands,#headlines,#related_carousel,#related_products .productWrapper', function() {

                load_owl();

                fetch('/?product-feed&format=json').then(function(response) {
                    if (response.ok) {
                        response.json().then(function(json) {

                            RAF(function() {

                                var relcount = $('#related_products > div').length - 1;

                                var createProduct = function(entry) {
                                    return '<div class="col-xs-12 productWrapper nopadding"><div class="product text-center"v><p class="label-sale">SALE - Veel Korting !</p><div class="image"><a href="/' + entry.url + '" data-iv="1"><img src="/w/' + entry.image + '/200x200x2/' + entry.url.replace('.html', '') + '.jpg"></a><form action="https://'+vk_domain+'/cart/add/' + entry.id + '/" class="product_configure_form" method="post"><a class="btn btn-view btn-sm btn-icon shopnow" title="Shop now" data-title="' + entry.url + '" href="/' + entry.url + '" data-iv="1">Koop Nu <i class="fa fa-shopping-cart" aria-hidden="true"></i></a></form></div><div class="icons margtop"></div><div class="content paddingsm"><a href="/' + entry.url + '" data-iv="1"><h4>' + entry.title + '</h4></a></div><div class="price"><hr><span class="old-price">&euro;' + entry.price.price_old.toFixed(2).toString().replace('.', ',') + ' </span><span class="price">&euro;' + entry.price.price.toFixed(2).toString().replace('.', ',') + '</span></div></div></div>';
                                }

                                if (json.popular) {
                                    $.each(json.popular, function(i, entry) {
                                        $('#related_carousel').append(createProduct(entry));

                                        if (relcount > 0 && relcount < 4) {
                                            var i = createProduct(entry);
                                            i = $(i).addClass('col-xs-6').addClass('col-sm-3').addClass('col-md-3').removeClass('col-xs-12');
                                            $('#related_carousel').before(i);
                                            relcount++;
                                        }
                                    });
                                }
                                if (json.featured) {
                                    $.each(json.featured, function(i, entry) {
                                        $('#related_carousel').append(createProduct(entry));

                                        if (relcount > 0 && relcount < 4) {
                                            var i = createProduct(entry);
                                            i = $(i).addClass('col-xs-6').addClass('col-sm-3').addClass('col-md-3').removeClass('col-xs-12');
                                            $('#related_carousel').before(i);
                                            relcount++;
                                        }
                                    });
                                }
                                if (json.newest) {
                                    $.each(json.newest, function(i, entry) {
                                        $('#related_carousel').append(createProduct(entry));

                                        if (relcount > 0 && relcount < 4) {
                                            var i = createProduct(entry);
                                            i = $(i).addClass('col-xs-6').addClass('col-sm-3').addClass('col-md-3').removeClass('col-xs-12');
                                            $('#related_carousel').before(i);
                                            relcount++;
                                        }
                                    });
                                }

                                if ($('#related_carousel > div').length) {
                                    load_owl().then(function() {

                                        RAF(function() {

                                            $('#related_carousel > div').css({
                                                visibility: 'visible'
                                            });

                                            $('#related_carousel').owlCarousel({
                                                items: 4,
                                                loop: true,
                                                margin: 0,
                                                dots: true,
                                                autoplay: true,
                                                autoplayTimeout: 1200,
                                                autoplayHoverPause: true,
                                                responsive: {
                                                    // breakpoint from 0 up
                                                    0: {
                                                        items: 2
                                                    },
                                                    // breakpoint from 768 up
                                                    768: {
                                                        items: 4
                                                    }
                                                }
                                            });

                                            $('#related_carousel > div').css({
                                                visibility: 'visible'
                                            });
                                        });
                                    });
                                }
                            });
                        });
                    } else {
                        console.error('response error', response);
                    }
                });
            });

        });
    }
    /*if ($('.nav-tabs').length) {
        $('.nav-tabs').append('<li class="slide-line"></li>');
        // animate slide-line on click
        $(doc).on('click', '.nav-tabs li a', function() {

            if ($(this).hasClass('in')) { //if selected
                $(this).removeClass('in').slideUp(); //slideup
            } else { //if not selected
                $(this).parent('.nav-tabs').find('.in').removeClass('in').slideUp(); //close other branches
                $(this).addClass('in').slideDown(); //slideDown
            }

            return false;
        });
        $('.nav-tabs > li a').first().trigger("click");
    }*/
    $('#filter_form input, #filter_form select, #filter_form2 input, #filter_form2 select, #filter_form3 input, #filter_form3 select, #filter_form4 input, #filter_form4 select')
        .not('[name="tabs"]')
        .on('change', function() {
            $(this).closest('form').submit();
        });

    if (doc.getElementById("collection-filter-price")) {

        $lazy('#collection-filter-price', function() {

            // load slider
            sliderjs().then(function() {
                RAF(function() {

                    var slideChangeTimeout;

                    var range = $('#collection-filter-price');
                    range.addClass('min-max-slider');
                    var minmax = range.parent().next();
                    if (minmax.hasClass('sidebar-filter-range')) {
                        minmax.remove();
                    }
                    range.html('<input class="min" name="min" type="range" step="1" min="'+vkConfig[6]+'" max="'+vkConfig[7]+'" value="'+$('#filter_form_min').val()+'" /><input class="max" name="max" type="range" step="1" min="'+vkConfig[6]+'" max="'+vkConfig[7]+'" value="'+$('#filter_form_max').val()+'" />');
                    win.slider(range[0], function(values) {
                        $('#filter_form_min').val(values[0]);
                        $('#filter_form_max').val(values[1]);

                        if (slideChangeTimeout) {
                            clearTimeout(slideChangeTimeout);
                        }
                        slideChangeTimeout = setTimeout(function() {
                            $('#filter_form4').submit();
                        }, 2000);
                    });
                });
            });
        });
    }

    $body.on('click', '.panel-group [name="tabs"]', function() {
        if ($(this).is(':checked')) {
            if ($(this).data('checked') === 1) {
                $(this).prop('checked', false);
                $(this).data('checked', 0);
            } else {
                $(this).data('checked', 1);
            }
        }
    });

    // search
    var searchjs_loaded;
    $body.on('mouseover touchstart mousedown', '#srch, .stickysearch', function() {
        if (!searchjs_loaded) {
            searchjs_loaded = true;
            srchjs();
        }
    });

    var cart;
    if (localStorage) {
        cart = localStorage.getItem('verkoop-cart');
        if (cart) {
            try {
                cart = JSON.parse(cart);
            } catch (e) {
                cart = false;
            }
        }
    }

    function update_cart_display(cart) {
        RAF(function() {
            $('.cart-total-quantity,.cart-total-price').each(function(i, el) {
                if ($(el).hasClass('cart-total-price')) {
                    $(el).html('&euro;' + cart.price.formatMoney(2, ',', '.'));
                } else {
                    $(el).html(cart.total);
                }
            });
        });
    }

    function update_cart_cache() {
        fetch('https://'+vk_domain+'/cart/?format=json', {
            credentials: 'include'
        }).then(function(response) {
            if (response.ok) {
                response.json().then(function(res) {
                    if (res && res.cart) {
                        var cart = {
                            total: (res.cart.products) ? res.cart.products.length : 0,
                            price: parseFloat(res.cart.totals.grand_total)
                        };

                        update_cart_display(cart);

                        localStorage.setItem('verkoop-cart', JSON.stringify(cart));
                    }
                });
            } else {
                console.error('invalid response', response);
            }
        });
    }

    win.update_cart_cache = update_cart_cache;

    if (cart) {
        update_cart_display(cart);
    } else {
        update_cart_cache();
    }

    // stock js
    $lazy('#vkProductContainer,#vk-push-subscribe', function() {
        stckjs();
    })

    RAF(function() {

        // Bereken de hoogt van de heightsub class
        var heightsubnav = $('.current .sub-menu').outerHeight();
        $('.sub-bg-menu').css({
            'height': heightsubnav
        });

        $("#clearField").toggle(Boolean($(".form-control").val()));

        //Activeer doubletap voor touch devices
        //$('.inner li:has(has-submenu)').doubleTapToGo();

        if ($win.width() > 992) {
            $('#menu').addClass('open');
        }

        //checken of tekst meer dan 500 karakters heeft
        if ($('.collection-content > .txt').height() > 110) {
            $('.show-more').css('display', 'block');
        } else {
            $('.show-more').css('display', 'none');
        }

        rewrite_ext_links();
    });
    
})(jQuery, window, document, window.RAF);
} catch(e){_st_catch(e)}
